// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OLxr","colMin":"styles_colMin__2-EAG"};